export enum BraceOrderStatus {
  Pending = 'pending',
  TwinReady = 'twin-ready',
  Delivered = 'delivered',
}
